import { createContext, useCallback, useMemo, useState } from "react";
import { Api } from "../utils/api";

const SavedRoadmapContext = createContext()

export const SaveRoadmapProvider = ({ children }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [savedList, setSavedList] = useState(null) // cached list of roadmaps

    const savedRoadmap = useCallback(async ({ roadmapRoute }) => {
        setLoading(true)
        setError(null)
        try {
            const res = await Api.post("/saved-roadmap", { roadmapRoute });
            // update cached list if present
            if (res?.data?.data && savedList) {
                setSavedList(prev => [...prev, res.data.data]);
            }
            return res.data;
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    }, [savedList])

    const deleteSavedRoadmap = useCallback(async ({ roadmapRoute }) => {
        setLoading(true)
        setError(null)
        try {
            const res = await Api.post(`/saved-roadmap/delete-savedRoadmap`, { roadmapRoute });
            // remove from cache
            if (res?.data?.success && savedList) {
                setSavedList(prev => prev.filter(item => item.roadmapRoute !== roadmapRoute));
            }
            return res.data;
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    }, [savedList])

    const getSavedRoadmapByUser = useCallback(async () => {
        if (savedList !== null) {
            return savedList;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await Api.get("/saved-roadmap/get-savedRoadmap-user");
            setSavedList(res.data.data);
            return res.data.data;
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    }, [savedList])

    const value = useMemo(() => ({
        loading,
        error,
        savedRoadmap,
        deleteSavedRoadmap,
        getSavedRoadmapByUser,
    }), [loading, error, savedRoadmap, deleteSavedRoadmap, getSavedRoadmapByUser]);

    return (
        <SavedRoadmapContext.Provider value={value}>{children}</SavedRoadmapContext.Provider>
    )
}

export default SavedRoadmapContext
